module.exports = __webpack_public_path__ + "img/MG_2627.743beb98.jpg";